import { Moon, Sun } from 'lucide-react';
import type { JSX } from 'react';

import { IconButton } from '../IconButton.js';

import { useTheme } from './ThemeProvider.js';

/** Icon button that toggles between light and dark color schemes. */
export function ThemeToggle(): JSX.Element {
  const { theme, toggleTheme } = useTheme();

  return (
    <IconButton
      aria-label={theme === 'light' ? 'Switch to dark theme' : 'Switch to light theme'}
      onClick={toggleTheme}
    >
      {theme === 'light' ? (
        <Moon aria-hidden="true" size={16} />
      ) : (
        <Sun aria-hidden="true" size={16} />
      )}
    </IconButton>
  );
}
